module.exports = __webpack_public_path__ + "img/3_5.39b61677.png";